import { IUserSettingsRejected } from '../../../actions/userObject/settings/requestFetchUserSettings'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IUserSettingsRejected,
): IUserObjectStore {
  return {
    ...state,
    settingsRequest: {
      ...state.settingsRequest,
      errMessage: action.errMessage,
      isLoading: true,
    },
  }
}
